<script>
  import tippy from 'tippy.js';
  import WelcomeNoteModal from './modal/WelcomeNoteModal.svelte';
  import { getCurrentUserStore } from '@stores/current_user';
  import { getGroupStore } from '@stores/group';
  let groupStore = getGroupStore('groupStore');

  import { getProfileStore } from '@stores/profile';
  let groupsStore = getProfileStore('groupsStore');

  import { onMount } from 'svelte';

  export let tooltipMessageContent = 'Welcome note is active';
  export let location;
  export let groupId;
  export let mobile = false;

  let group;
  let currentUser = getCurrentUserStore('default');
  let showWelcomeNoteModal = false;
  let welcomeNoteEditMode = false;

  let setupTippy = (node, data) => {
    if (mobile) {
      return;
    }

    let instance = tippy(node, {
      content: data,
    });

    return {
      destroy() {
        try {
          instance.destroy();
        } catch {}
      },
    };
  };

  let showWelcomeNote = function (edit) {
    showWelcomeNoteModal = true;

    if (!mobile) {
      welcomeNoteEditMode = edit;
    }
  };

  onMount(() => {
    group = groupId ? groupsStore.find(groupId) : groupStore;
    let unsubGroup = group.subscribe((x) => (group = x));

    return () => {
      unsubGroup();
    };
  });
</script>

<style style="text/scss" lang="scss">
  // @todo scope new changes to a flag to be used on new tile

  .welcome-active {
    margin-right: 2px;
    cursor: pointer;

    &.profile-cover-photos {
      padding-top: 10px;

      &.mobile {
        padding-top: 9px;
        margin-right: 2px;
      }
      > a > svg {
        height: 20px;
        path {
          fill: #d5cfea;
          transition: 0.25s;
        }
      }
      &:hover {
        path {
          fill: #a893f9 !important;
        }
      }
    }
  }
</style>

{#if group && group.permissions.edit && group.welcome_note_enabled}
  <div
    class="welcome-active"
    class:profile={location === 'profile'}
    class:profile-new={location === 'profileNew'}
    class:profile-cover-photos={location === 'profileCoverPhotos'}
    class:mobile={mobile}
    use:setupTippy={tooltipMessageContent}>
    {#if showWelcomeNoteModal}
      <WelcomeNoteModal
        group={group}
        mobile={mobile}
        currentUser={currentUser}
        on:close={() => {
          showWelcomeNoteModal = false;
        }}
        bind:edit={welcomeNoteEditMode} />
    {/if}
    <a
      href="#"
      on:click|preventDefault|stopPropagation={() => {
        showWelcomeNote(false);
      }}
      class="welcome-note-modal-link">
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
        <path
          d="M21.2539 2C6.25391 2 4.25391 16 3.25391 22C3.92058 22 4.58666 22 5.25215 22C5.91812 18.6669 7.58537 16.8336 10.2539 16.5C14.2539 16 17.2539 12.5 18.2539 9.5L16.7539 8.5C17.0872 8.16667 17.4206 7.83333 17.7539 7.5C18.7539 6.5 19.7581 5 21.2539 2Z"
          fill="#D6CFEA" />
      </svg>
    </a>
  </div>
{/if}
